if (!customElements.get("complementary-products")) {
  const SELECTORS = {
    container: '[data-td-complementary-products-container]',
  };

  class ComplementaryProducts extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.tdProductId;
      this.container = this.querySelector(SELECTORS.container);
      this.observer = null;
      this.loaded = false;
    }

    connectedCallback() {
      if (this.productId) {
        this.initIntersectionObserver();
      } else {
        console.warn('Complementary products: No product ID provided');
        this.showEmptyState();
      }
    }

    initIntersectionObserver() {
      if (this.loaded || !window.IntersectionObserver) {
        this.loadComplementaryProducts();
        return;
      }

      const options = {
        root: null,
        rootMargin: '0px 0px 200px 0px',
        threshold: 0.1
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.loaded) {
            this.loadComplementaryProducts();
          }
        });
      }, options);

      this.observer.observe(this);
    }

    async loadComplementaryProducts() {
      if (this.loaded) return;
      
      this.loaded = true;
      
      try {
        const url = `/recommendations/products?product_id=${this.productId}&intent=complementary&limit=6&section_id=td-product-recommendations`;
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'text/html',
            'X-Requested-With': 'XMLHttpRequest',
          },
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const text = await response.text();
        const html = document.createElement('div');
        html.innerHTML = text;
        
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.container.innerHTML = recommendations.innerHTML;
          this.container.classList.add('loaded');
        } else {
          console.log('Complementary products: No recommendations found, removing section');
          this.remove();
        }
      } catch (error) {
        console.error('Error loading complementary products:', error);
        this.showEmptyState();
      } finally {
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    }

    showEmptyState() {
      this.container.innerHTML = `
        <div class="product-complementary__empty">
          <p>No complementary products found.</p>
        </div>
      `;
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  customElements.define("complementary-products", ComplementaryProducts);
}
